import React from 'react'
const Home = React.lazy(() => import('../pages/Home'))
const Projects = React.lazy(() => import('../pages/Projects'))
const HowWeWork = React.lazy(() => import('../pages/HowWeWork'))
const OurPrinciples = React.lazy(() => import('../pages/OurPrinciples'))
const OurPartnerships = React.lazy(() => import('../pages/OurPartnerships'))
const UptoParents = React.lazy(() => import('../pages/UptoParents'))
const AssessFamilyLaw = React.lazy(() => import('../pages/AssessFamilyLaw'))
const DefenseMap = React.lazy(() => import('../pages/DefenseMap'))
const ProhibitionBlunder = React.lazy(() => import('../pages/ProhibitionBlunder'))
const ContactUs = React.lazy(() => import('../pages/ContactUs'))
const FamilyCourtWebsite = React.lazy(() => import('../pages/FamilyCourtWebsite'))
const homeRoutes = [
  { path: '/', exact: true, name: 'Home', element: Home },
  { path: '/projects', exact: true, name: 'Projects', element: Projects },
  { path: '/howwework', exact: true, name: 'HowWeWork', element: HowWeWork },
  { path: '/ourprinciples', exact: true, name: 'OurPrinciples', element: OurPrinciples },
  { path: '/ourpartnerships', exact: true, name: 'OurPartnerships', element: OurPartnerships },
  { path: '/uptoparents', exact: true, name: 'UptoParents', element: UptoParents },
  { path: '/assessfamilylaw', exact: true, name: 'AssessFamilyLaw', element: AssessFamilyLaw },
  { path: '/defensemap', exact: true, name: 'DefenseMap', element: DefenseMap },
  { path: '/contactus', exact: true, name: 'ContactUs', element: ContactUs },
  {
    path: '/familycourtwebsite',
    exact: true,
    name: 'FamilyCourtWebsite',
    element: FamilyCourtWebsite,
  },
  {
    path: '/prohibitionblunder',
    exact: true,
    name: 'ProhibitionBlunder',
    element: ProhibitionBlunder,
  },
]

export { homeRoutes }
